var render, staticRenderFns
import script from "./auto-auth.vue?vue&type=script&lang=js&"
export * from "./auto-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23703cb6')) {
      api.createRecord('23703cb6', component.options)
    } else {
      api.reload('23703cb6', component.options)
    }
    
  }
}
component.options.__file = "src/views/login/auto-auth.vue"
export default component.exports